// v3 introduced percent-encoded ref fields + a session projectId slot. The wire
// format changed incompatibly from v2 (which tail-joined raw pad names), so the
// version is bumped: stale v2 values are ignored rather than mis-decoded.
export const PERSISTENCE_VERSION = 'v3'

export const MULTIVIEW_LIMITS = {
  maxFeeds: 16,
} as const

export const MULTIVIEW_TIMINGS = {
  sessionStatusPollInterval: 15_000,
  inactiveProjectPollInterval: 30_000,
  /** Detects external stops (e.g. another user stopping the project) */
  activeProjectPollInterval: 120_000,
} as const

export const FALLBACK_SESSION_COLOR = '#718096'

// 14 hues ~26° apart, offset so only two land in the green band (120–190),
// keeping the vivid solo green distinct; two low-chroma greys round out 16
const SESSION_HUES = [
  12, 38, 63, 89, 115, 141, 166, 192, 218, 243, 269, 295, 320, 346,
] as const

export const SESSION_COLORS = [
  ...SESSION_HUES.map((hue) => `oklch(60% 0.15 ${hue})`),
  'oklch(60% 0.03 250)',
  'oklch(60% 0.03 60)',
]
